import { DealActivityStatus } from '@trnsact/trnsact-shared-types';

export enum ActivityPageTabs {
  ALL = 'ALL',
  NOTE = 'NOTE',
  CALL = 'CALL',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  EVENT = 'EVENT',
}

export enum ActivityType {
  NOTE = 'NOTE',
  CALL = 'CALL',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  EVENT = 'EVENT',
}

export interface EventListFilters {
  ownerId: string;
  dateTo: string | null;
  dateFrom: string | null;
  opportunityId: string;
  status: DealActivityStatus[];
}

export interface ActivityListFilters {
  search: string;
  eventFilters: EventListFilters;
  callFilters: {
    callStatus: string[];
    callDirection: string[];
  };
}

export interface ActivityCardProps<Entity> {
  entity: Entity;
  onUpdate?: VoidFunction;
  onDelete?: VoidFunction;
}

export interface SmsConversationData {
  voId: string;
  conversationSequenceNumber: number | null;
  contactId: string | null;
  contactName: string;
  contactPhone: string | null;
  contactTitle: string | null;
  contactInitials: string;
  isAgent?: boolean;
  demoMode?: boolean;
}

export interface SendMessageForm {
  message: string;
}
